import { render, staticRenderFns } from "./DonateCardFundraising.vue?vue&type=template&id=7070a038&"
import script from "./DonateCardFundraising.vue?vue&type=script&lang=js&"
export * from "./DonateCardFundraising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports